'use es6';

import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import { getMessageId } from 'conversations-message-history/message-history/operators/getMessageId';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "MessageClippedLink__StyledWrapper",
  componentId: "sc-1gne7nm-0"
})(["margin-top:5px;"]);
const MessageClippedLink = message => {
  const messageId = getMessageId(message);
  const hublet = enviro.getHublet();
  const getEnv = () => enviro.getInternal('api') === 'qa' ? 'qa' : '';
  const getHubletDomain = () => hublet === 'na1' ? 'api' : `api-${hublet}`;
  const href = `//${getHubletDomain()}.hubspot${getEnv()}.com/conversations-email/v1/app-messages/${messageId}/static-redirect?portalId=${PortalIdParser.get()}`;
  return /*#__PURE__*/_jsx(StyledWrapper, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "conversations-inbox-message-history.common-message.clippedMessageLink_jsx",
      options: {
        href
      },
      elements: {
        UILink
      }
    })
  });
};
MessageClippedLink.displayName = 'MessageClippedLink';
export default MessageClippedLink;